import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { IntercomAPI } from 'react-intercom'

import config from 'config'
import generalActions from 'redux/actions/generalActions'
import { myAccountSelectors } from 'redux/selectors'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.MY_ACCOUNT_ADVANCED_ENABLE_SETTING

function confirmAction(btnAction, intercomIO) {
	if (btnAction == 2) {
		if (intercomIO) {
			IntercomAPI('showNewMessage', localize('my_account_advanced_confirm_message_notes'))
		}
	} else if (btnAction == 1) {
		window.open(config.www+'get-gold', '_self')
	}
}

const AdvancedEnableSettingConfirm = props => (<Confirm
	btOne={props.advancedSettings[props.index].buttons[1].text}
	btTwo={props.advancedSettings[props.index].buttons[0].text}
	alertTitle={props.advancedSettings[props.index].offerTitle}
	alertMessage={props.advancedSettings[props.index].offerMessage}
	actionButtonType={0}
	actionOne={() => props.actions.closeConfirm(CONFIRM_TYPE)}
	actionTwo={
		() => {
			confirmAction(props.advancedSettings[props.index].buttons[0].action, props.intercomIO)
			props.actions.closeConfirm(CONFIRM_TYPE)
		}
	}
	centeredTitle={true}
	closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
/>)

function mapStateToProps(state) {
	return myAccountSelectors.advancedViewSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedEnableSettingConfirm)
